"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CddConductedPhaseRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.CddConductedPhaseRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.cdd_conducted_phase.label',
    fallbackLabel: 'CDD conducted phase',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'BEFORE_ACCOUNT_CREATION', label: 'fields.enm.cdd_conducted_phase.options.BEFORE_ACCOUNT_CREATION', fallbackLabel: 'Before the merchant opens its account' },
        { key: 'AFTER_ACCOUNT_CREATION', label: 'fields.enm.cdd_conducted_phase.options.AFTER_ACCOUNT_CREATION', fallbackLabel: 'After account creation but before the merchant is allowed to transact' },
        { key: 'BEFORE_SETTLEMENT_INITIATED', label: 'fields.enm.cdd_conducted_phase.options.BEFORE_SETTLEMENT_INITIATED', fallbackLabel: 'After account creation and after the merchant is allowed to transact but before settlement of funds to the merchant are initiated' },
        { key: 'OTHER', label: 'fields.enm.cdd_conducted_phase.options.OTHER', fallbackLabel: 'Other' },
    ],
    trackFieldValueWithAnalytics: false,
};
